// extracted by mini-css-extract-plugin
export default {"container":"BillingCalculationStats_container__i2MIO","containerSummary":"BillingCalculationStats_containerSummary__n8eHp","title":"BillingCalculationStats_title__3j6yo"};